import TextLink from './TextLink'

export default TextLink
